import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { runOwsRequestWithMonitor, Feature, fullResponseOperationOption } from '../../shared';
import { UpdateFolderJsonResponse, UpdateFolderRequest, getServiceAsync } from '../../service';

export function renameFolder(id: string, newName: string): Promise<UpdateFolderJsonResponse> {
    return getServiceAsync().then(service => {
        const request: UpdateFolderRequest = service.Factory.updateFolderRequest({
            FolderChanges: [
                service.Factory.folderChange({
                    FolderId: service.Factory.folderId({ Id: id }),
                    Updates: [
                        service.Factory.setFolderField({
                            Path: service.Factory.propertyUri({ FieldURI: 'FolderDisplayName' }),
                            Folder: service.Factory.folder({ DisplayName: newName }),
                        }),
                    ],
                }),
            ],
        });

        return runOwsRequestWithMonitor({
            scenarioName: 'RenameFolder',
            feature: Feature.FolderManagement,
            operation: () =>
                service.Operation.updateFolderOperation(
                    {
                        Header: getJsonRequestHeader(),
                        Body: request,
                    },
                    fullResponseOperationOption
                ),
            transformResponse: (response: UpdateFolderJsonResponse) => response,
        });
    });
}
